import { render, staticRenderFns } from "./creditNoteAllocationDialog.vue?vue&type=template&id=23f1801c&scoped=true&"
import script from "./creditNoteAllocationDialog.vue?vue&type=script&lang=js&"
export * from "./creditNoteAllocationDialog.vue?vue&type=script&lang=js&"
import style0 from "./creditNoteAllocationDialog.vue?vue&type=style&index=0&id=23f1801c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1801c",
  null
  
)

export default component.exports